module.exports = __webpack_public_path__ + "28cd69e778410536d2e898286e2b36d1.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/accounts/import/result/import-result.html
// module id = 1938
// module chunks = 0